import React from 'react';
import PropTypes from 'prop-types';
import ReduxActions from 'reduxActions';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import withRouterHooks from 'utils/routerHelper';
import Edit from './edit';

class JobEditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: this._getDefaultForm(props.data || {}),
      error: {},
      isChanged: false,
    };
  }

  UNSAFE_componentWillMount() {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.Job.page.loadingItem);
    this.props.dispatch(ReduxActions.job.fetch(Utils.Router.getParams().id))
      .then(() => {
        this.props.dispatch(ReduxActions.constant.fetchList());
      })
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this._updateForm(this.props.data);
    }
  }

  _updateForm(data) {
    this.setState({ form: this._getDefaultForm(data) });
  }

  _getDefaultForm(data = {}) {
    const baseTask = data.base_task || {};

    return {
      job_type: data.job_type || 'delivery',
      base_task_attributes: {
        billing_account_id: baseTask.billing_account_id
          || (baseTask.billing_account && baseTask.billing_account.id),
        address_attributes: this._getDefaultAddress(baseTask.address || {}),
        time_type: baseTask.time_type,
        time_from: baseTask.time_from,
        time_to: baseTask.time_to,
        time_window_id: Utils.Helper.isNullOrUndefined(baseTask.time_window)
          ? baseTask.time_window_id : baseTask.time_window.id,
      },
      tag_list: Utils.Helper.isNullOrUndefined(data.tags) ? []
        : data.tags.map(tag => tag.name).filter(tag => tag !== 'Point-to-Point'),
      remarks: data.remarks,
      attachments_attributes: this._getAttachmentsDefaultForm(data),
    };
  }

  _getAttachmentsDefaultForm = (data) => {
    const attachments = data.attachments || [];
    return attachments.map(attachment => ({
      id: attachment.id,
      name: attachment.name,
      url: attachment.url,
    }));
  }

  _getDefaultAddress = address => ({
    name: address.name || null,
    line_1: address.line_1 || null,
    line_2: address.line_2 || null,
    city: address.city || null,
    country: address.country || null,
    zip: address.zip || null,
    contact_person: address.contact_person || null,
    contact_number: address.contact_number || null,
    email: address.email || null,
  });

  _isPointToPoint = (data) => {
    const p2p = data.job_type === 'p2p';
    return p2p || (data.job_type === 'delivery' && data.tags && data.tags.filter(tag => tag.name === 'Point-to-Point').length > 0);
  }

  _onFormChange(fieldName, value) {
    let form;
    if (!this.state.isChanged) {
      this.setState({ isChanged: true });
    }
    if (fieldName === 'customer_id') {
      if (value !== '') {
        this.props.dispatch(ReduxActions.customer.fetch(value));
      }
      form = {
        ...this.state.form,
        customer_id: value === '' ? null : value,
        base_task_attributes: {
          ...this.state.form.base_task_attributes,
          billing_account_id: null,
        },
      };
      this.setState({ form });
    } else if (fieldName === 'job_type' && value !== 'p2p') {
      form = {
        ...this.state.form,
        job_type: value,
        base_task_attributes: {
          ...this.state.form.base_task_attributes,
          billing_account_id: null,
        },
      };
      this.setState({ form });
    } else if (fieldName === 'base_task_attributes.billing_account_id') {
      if (value && value !== '') {
        this.props.dispatch(ReduxActions.billingAccount.fetch(value));
      }
      form = {
        ...this.state.form,
        base_task_attributes: {
          ...this.state.form.base_task_attributes,
          billing_account_id: value,
        },
      };
      this.setState({ form });
    } else {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, fieldName, value),
      }));
    }
  }

  _save = () => {
    let form = this.state.form;
    if (this._isPointToPoint(this.props.data)) {
      form = {
        ...this.state.form,
        tag_list: this.state.form.tag_list.concat(['Point-to-Point']),
      };
    }

    Utils.FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.Job.form.saving);
    this.props.dispatch(ReduxActions.job.update(this.props.data.id, form))
      .then(() => {
        this.props.navigate('..', { relative: 'path' });
      })
      .catch((error) => {
        this.setState({ error });
      })
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  _renderMenu() {
    if (this.props.data != null && this.props.data.guid) {
      return (
        <Components.Form.Title>
          <Components.Form.Title.Item isHighlighted>
            {`Editing Job #${this.props.data.guid}`}
          </Components.Form.Title.Item>
        </Components.Form.Title>
      );
    }

    return false;
  }

  _renderRightPanel() {
    return (
      <Components.Form.RightPanel>
        <Components.Button
          iconClassName="versa-completed"
          id="vf-job__edit-form__right-panel__save-button"
          onClick={this._save}
        >
          {this.props.strings.Job.form.buttons.save}
        </Components.Button>
      </Components.Form.RightPanel>
    );
  }

  render() {
    const { form, error } = this.state;
    const {
      data, constant, customer, optionAddresses,
    } = this.props;
    const hasRequiredData = !Utils.Helper.isEmptyObject(data) && !Utils.Helper.isEmptyObject(form);

    return (
      <Components.Form.CoreLayout
        isChanged={this.state.isChanged}
        onClose={() => (this.props.location.pathname.includes('submissions')
          ? this.props.navigate('/submissions')
          : this.props.navigate('/in_progress'))}
        rightPanel={this._renderRightPanel()}
        title={this._renderMenu()}
      >
        {hasRequiredData && (
          <Edit
            constant={constant}
            customer={customer}
            data={data}
            error={error}
            form={form}
            id="vf-job__edit-form__left-panel"
            onFormChange={(key, val) => this._onFormChange(key, val)}
            optionAddresses={optionAddresses}
          />
        )}
      </Components.Form.CoreLayout>
    );
  }
}

JobEditForm.propTypes = {
  constant: PropTypes.shape().isRequired,
  customer: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({
    base_task: PropTypes.shape({
      billing_account_id: PropTypes.number,
      billing_account: PropTypes.shape({
        id: PropTypes.number,
      }),
      address: PropTypes.shape(),
      time_type: PropTypes.string,
      time_from: PropTypes.string,
      time_to: PropTypes.string,
      time_window: PropTypes.shape(),
      time_window_id: PropTypes.number,
    }),
    guid: PropTypes.string,
    id: PropTypes.number,
    job_type: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
    remarks: PropTypes.string,
    attachments: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      url: PropTypes.string,
    })),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  optionAddresses: PropTypes.arrayOf(PropTypes.shape()),
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      page: PropTypes.shape({
        loadingItem: PropTypes.string,
      }),
      form: PropTypes.shape({
        saving: PropTypes.string,
        buttons: PropTypes.shape({
          save: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

JobEditForm.defaultProps = {
  optionAddresses: [],
};

const mapStateToProps = (state, ownProps) => {
  const { job, profile, constant } = state;
  return {
    data: job.jobs[ownProps.params.id] || {},
    constant: constant.constant,
    customer: profile.profile,
    optionAddresses: [],
    isUpdating: job.isUpdating,
  };
};

export default withRouterHooks(connect(mapStateToProps)(translate('')(JobEditForm)));
